import {
  Dashboard,
  ApiDocs,
  Webhooks,
  Bugs,
  Shopify,
  Settings,
  PandaScore,
  PageNotFoundPage,
  IndexPage,
  ClickUp,
} from "@/routes/routeComponents";
import PandaLoadingIndicator from "@/components/PandaLoadingIndicator";
import PrivateRoute from "@/utils/auth/privateRoute";
import {
  API_DOCS_PAGE,
  WEBHOOKS_PAGE,
  BUGS_PAGE,
  DASHBOARD_PAGE,
  FEATURE_REQUEST_PAGE,
  INDEX_PAGE,
  PANDA_SCORE_PAGE,
  SETTINGS_PAGE,
  SHOPIFY_PAGE,
  ORG_SETTINGS_PAGE,
} from "@/utils/pageUrls";
import { Suspense, lazy } from "react";
import { Outlet, Route, Routes } from "react-router";
import { SettingProvider } from "@/providers/SettingProvider";

const OrgSettings = lazy(() => import("@/features/org-settings"));

const RoutesComponent = () => {
  return (
    <Suspense fallback={<PandaLoadingIndicator />}>
      <Routes>
        <Route path={INDEX_PAGE} element={<IndexPage />} />

        <Route element={<PrivateRoute />}>
          <Route
            element={
              <SettingProvider>
                <Outlet />
              </SettingProvider>
            }
          >
            <Route path={DASHBOARD_PAGE} element={<Dashboard />} />
            <Route path={API_DOCS_PAGE} element={<ApiDocs />} />
            <Route path={WEBHOOKS_PAGE} element={<Webhooks />} />
            <Route path={FEATURE_REQUEST_PAGE} element={<ClickUp />} />
            <Route path={BUGS_PAGE} element={<Bugs />} />
            <Route path={SETTINGS_PAGE} element={<Settings />} />
            <Route path={SHOPIFY_PAGE} element={<Shopify />} />
            <Route path={PANDA_SCORE_PAGE} element={<PandaScore />} />
            <Route path={ORG_SETTINGS_PAGE} element={<OrgSettings />} />
          </Route>

          <Route path="*" element={<PageNotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;
